import { observable, action, computed } from "mobx";
import toastService from "../services/ToastService";
import Exporter from "src/services/Exporter"
import moment from "moment";
import _ from "lodash";
import validationService from "src/services/ValidationService";


import { 
  ApprovalCoreApprovalStatusesBranchTypesByFetchType,
  ExportSubFunction,
  FILE_FORMAT,
} from "../constants/constants-container";

export default class ApprovalsChangesStore {

  constructor(http, maintenanceAgencyStore) {
    this.http = http;
    this.maintenanceAgencyStore = maintenanceAgencyStore;
    this.exporter = new Exporter(http)
  }

  @observable showApprovalsChangesModalMap = observable.map(
    {
      "da_changes_in_branch": false,
      "mao_pending_core_approvals_in_all_projects": false,
      "mao_pending_core_approvals_in_project": false,
      "mao_promote_core_proposals_in_all_projects": false,
      "mao_promote_core_proposals_in_project": false,
      "mao_changes_in_master_branch": false,
      "mao_changes_in_release": false,
      "po_pending_approvals": false,
      "po_pending_approvals_in_project": false,
      "po_changes_in_master_branch": false,
      "po_approved_changes": false,
      "po_changes_in_release": false,
    }
  );

  @observable latestSelectedReleaseOrDABranchBid = null;
  @observable tableData = [];
  @observable changesByTableId = new Map();
  @observable selectedTypes = [];
  @observable includeChanges = true;
  @observable businessId = null;
  @observable useRegexPatternMatching = false;
  @observable approvalStatusFilter = "ALL";

  @observable totalResultsCount = -1;
  @observable limit = {
      "limit": 10,
      "offset": 0
  };

  @observable sorted = [];
  @observable filtered = [];

  @observable
  approvalsChangesData = {
    items: []
  };

  @observable
  approvalsChangesModalData = {
    selection: [],
    selectAll: false
  };

  @observable
  fastTrackProjectsProjectsWithMasterEntities = {};

  @action
  toggleApprovalsChangesModalVisibility = key => {
    this.showApprovalsChangesModalMap.set(key, !this.showApprovalsChangesModalMap.get(key));
    this.resetApprovalsChangesModalData(key);
  }

  @action
  toggleAll = (selectAll, selection) => {
    this.approvalsChangesModalData = {
      ...this.approvalsChangesModalData,
      selectAll: selectAll,
      selection: selection
    };
  }

  @action
  toggleSelection = selection => {
    this.approvalsChangesModalData = {
      ...this.approvalsChangesModalData,
      selection: selection
    };
  }

  @action
  resetApprovalsChangesModalData = key => {
    this.tableData = [];
    this.approvalsChangesModalData = {
      selection: [],
      selectAll: false
    };
    this.selectedTypes = [];
    this.businessId = null;
    this.useRegexPatternMatching = false;
    this.includeChanges = true;
    if (key === 'da_changes_in_branch')
      this.approvalStatusFilter = "DRAFT";
    else
      this.approvalStatusFilter = "ALL";
  }

  @action
  fetchApprovalsChangesData = (idsByKey, approvalStatusesAndBranchTypes, actionType, validationType, trackingParams) => {
    const fetchParams = {
      idsByKey: idsByKey,
      approvalStatusesAndBranchTypes: approvalStatusesAndBranchTypes,
      objectTypes: this.selectedTypes,
      includeChanges: this.includeChanges,
      businessId: this.businessId,
      useRegexPatternMatching: this.useRegexPatternMatching,
      approvalStatusFilter: this.approvalStatusFilter,
      limit: this.limit,
      action: actionType,
      validationType: validationType,
      trackingParams: trackingParams,
    };
    const entityFilter = this.getEntityFilterForApprovalsChangesData(fetchParams)
    fetchParams.entityFilter = entityFilter

    validationService.setLastApprovalChangesQueryByValidationIssuer(validationType.issuer, entityFilter)

    this.http
      .fetchApprovalsChangesData(fetchParams)
      .then(
        action(data => {
          this.approvalsChangesData = data;
          this.maintenanceAgencyStore.helper_fetch_all_frameworks();
          this.maintenanceAgencyStore.helper_fetch_all_projects();

          if (data && data.items) {
            this.changesByTableId.clear();
            this.totalResultsCount = data.totalResults;
            this.tableData = data.items.map((item, index) => {
              return {
                _id: item.entity.tid,
                type: item.entity.type || "N/A",
                tid: item.entity.tid || "N/A",
                businessIdValue: item.entity.businessIdValue || "N/A",
                action: item.action || "N/A",
                date: item.actionTimestamp
                  ? moment(item.actionTimestamp).format("DD.MM.YYYY")
                  : "N/A",
                actorName: item.actorDisplayName || "N/A",
                maintenanceAgencyName: item.maintenanceAgencyName || "N/A",
                maintenanceAgencyCode: item.maintenanceAgencyCode || "N/A",
                projectName: item.projectName || "N/A",
                projectType: item.projectType || "N/A",
                branchName: item.branchName || "N/A",
                branchType: item.branchType || "N/A",
                approvalStatus: item.entity.approvalStatus || "N/A",
                coreApprovalStatus: item.entity.coreApprovalStatus || "N/A",
            
                lastContentChangeWhen: item.lastContentChangeWhen
                  ? moment(item.lastContentChangeWhen).format("DD.MM.YYYY")
                  : "N/A",
                lastContentChangeActorDisplayName: item.lastContentChangeActorDisplayName || "N/A",
                lastApprovalChangeWhen: item.lastApprovalChangeWhen
                  ? moment(item.lastApprovalChangeWhen).format("DD.MM.YYYY")
                  : "N/A",
                lastApprovalChangeActorDisplayName: item.lastApprovalChangeActorDisplayName || "N/A",
                mergedWhen: item.mergedWhen
                  ? moment(item.mergedWhen).format("DD.MM.YYYY")
                  : "N/A",
                mergedActorDisplayName: item.mergedActorDisplayName || "N/A",
                lastCoreApprovalChangeWhen: item.lastCoreApprovalChangeWhen
                  ? moment(item.lastCoreApprovalChangeWhen).format("DD.MM.YYYY")
                  : "N/A",
                lastCoreApprovalChangeActorDisplayName: item.lastCoreApprovalChangeActorDisplayName || "N/A",
                promotedWhen: item.promotedWhen
                  ? moment(item.promotedWhen).format("DD.MM.YYYY")
                  : "N/A",
                promotedActorDisplayName: item.promotedActorDisplayName || "N/A",

                item: item
              };
            });
            this.tableData.forEach((tableItem, index) => {
              this.changesByTableId.set(tableItem._id, {
                tid: tableItem.item.entity.tid,
                type: tableItem.item.entity.type,
                eid: tableItem.item.entity.eid
              });
            });
          }
        })
      );
  }

  @action
  changeTableSettings = (state, instance) => {
    this.sorted = state.sorted;
    this.filtered = state.filtered;
    this.limit.limit = state.pageSize;
    this.limit.offset = this.limit.limit * state.page;
  }

  @action
  setLatestSelectedReleaseOrBranchBid = bid => {
    this.latestSelectedReleaseOrDABranchBid = bid;
  }

  @action
  approve = (type, callback) => {
    let actionType = this.getActionType(type, 'APPROVE');
    if (this.approvalsChangesModalData.selection.length > 0) {
      const jsonToSend = this.createJson(actionType);
      this.sendApproveOrRejectRequest(jsonToSend, callback);
    } else {
      const notificationMessage = this.getApproveRejectNotificationMessage(actionType);
      toastService.func_notify(
        notificationMessage,
        "error"
      );
    }
  }

  @action
  reject = (type, callback) => {
    let actionType = this.getActionType(type, 'REJECT');
    if (this.approvalsChangesModalData.selection.length > 0) {
      const jsonToSend = this.createJson(actionType);
      this.sendApproveOrRejectRequest(jsonToSend, callback);
    } else {
      const notificationMessage = this.getApproveRejectNotificationMessage(actionType);
      toastService.func_notify(
        notificationMessage,
        "error"
      );
    }
  }

  getApproveRejectNotificationMessage = (actionType) => {
    switch(actionType){
      case "SendEntitiesForApproval": return "Please select entities to be sent for approval.";
      case "ApproveEntities": return "Please select entities to be approved.";
      case "RejectEntities": return "Please select entities to be rejected.";
      case "ApproveCoreEntityProposals": return "Please select core entity proposals to be approved.";
      case "RejectCoreEntityProposals": return "Please select core entity proposals to be rejected.";
      case "PromoteCoreEntities": return "Please select approved core proposals to be promoted to production."
      default: console.error("Unexpected actionType: ", actionType);
    }
    
  }

  getActionType = (type,action) => {
    // PO
    if(type.includes("po_pending_approvals")) {
      return action === 'APPROVE' ? "ApproveEntities" : "RejectEntities";
    }
    // PO
    if(type.includes("po_changes_in_master_branch")) {
      return "PromoteNonFrameworkEntities";
    }
    // MAO
    if(type.includes("mao_pending_core_approvals")) {
      return action === 'APPROVE' ? "ApproveCoreEntityProposals" : "RejectCoreEntityProposals";
    }
    // MAO
    if(type.includes("mao_promote_core_proposals")) {
      return "PromoteCoreEntities";
    }
    // DA
    return "SendEntitiesForApproval";
  }

  sendApproveOrRejectRequest = (jsonToSend, callback) => {
    this.http.func_sendGeneralMessage(jsonToSend, response => {
      if (
        response &&
        response.resultType &&
        response.resultType === "SUCCESS" &&
        callback
      ) {
        callback();
      }
    });
  }

  createJson = (actionType) => {
    let jsonToSend = {};

    jsonToSend.actionType = actionType;
    jsonToSend.entities = [];

    this.approvalsChangesModalData.selection.forEach((id, index) => {
      // selection can contain entity tids which are already approved/rejected
      // and the latest querychanges result doesn't contain them
      if(this.changesByTableId.has(id)) {
        jsonToSend.entities.push(this.changesByTableId.get(id));
      }
    });
    return jsonToSend;
  }

  @action
  handleTypesOfObjectChange = selectedTypes => {
    this.selectedTypes = selectedTypes;
  }

  @action
  handleIncludeChangesChange = newCheckState => {
    this.includeChanges = newCheckState;
  }

  @action
  handleBusinessIdChange = businessId => {
    this.businessId = businessId;
  }

  @action
  handleBusinessIdMatchingTypeChange = useRegexPatternMatching => {
    this.useRegexPatternMatching = useRegexPatternMatching;
  }

  @action
  handleApprovalStatusFilterChange = newApprovalStatusObject => {
    this.approvalStatusFilter = newApprovalStatusObject.value;
  }

  @action
  fastTrackProjectIsReadyForPromotion = (project, ownerTypeBranch) => {
    let idsByKey = "";
    if (
      Object.keys(project.project).length > 0 &&
      project.masterBranch &&
      project.masterBranch.tid
    ) {
      idsByKey =  {
        bid: {
          in: [project.masterBranch.tid]
        }
      }
    }

    const fetchParams = {
      idsByKey: idsByKey,
      approvalStatusesAndBranchTypes: ApprovalCoreApprovalStatusesBranchTypesByFetchType.get(ownerTypeBranch),
      approvalStatusFilter: "ALL",
      objectTypes: [],
      includeChanges: true,
      limit: {limit: 10, offset: 0},
    };

    let totalResults = 0;

    const entityFilter = this.getEntityFilterForApprovalsChangesData(fetchParams)
    fetchParams.entityFilter = entityFilter

    this.http
      .fetchApprovalsChangesData(fetchParams)
      .then(
        action(data => {
          if (data && data.items) {
            totalResults = data.totalResults;
            if (totalResults > 0) {
                this.fastTrackProjectsProjectsWithMasterEntities[project.project.tid] = true;
            } else {
                this.fastTrackProjectsProjectsWithMasterEntities[project.project.tid] = false;
            }
          }
        })
      );
      return totalResults > 0;
  }

  @action
  fastTrackProjectContainsMasterEntities = (project, ownerTypeBranch) => {
      if (this.fastTrackProjectsProjectsWithMasterEntities.hasOwnProperty(project.project.tid)) {
        return this.fastTrackProjectsProjectsWithMasterEntities[project.project.tid];
      } else {
        return this.fastTrackProjectIsReadyForPromotion(project, ownerTypeBranch);
      }
  }

  isApprovalsChangesModalVisible = key => {
    return computed(() => this.showApprovalsChangesModalMap.get(key)).get();
  }

  @computed
  get getTableData() {
    const sortedAndFilteredTableData = this.sortAndFilterTableData();
    return sortedAndFilteredTableData;
  }

  sortAndFilterTableData = () => {
    let filteredData = [];

    if (this.filtered.length > 0) {
      this.tableData.forEach((row, rowIndex) => {
        let match = 0;
        this.filtered.forEach((filter, filterIndex) => {
          if(row[filter.id].includes(filter.value)) {
            match = match + 1;
          }
        })
        if(match === this.filtered.length) {
          filteredData.push(row);
        }
      })
    } else {
      filteredData = this.tableData;
    }

    const sortedTableData = _.orderBy(
      filteredData,
      this.sorted.map(sort => {
        return row => {
          if (row[sort.id] === null || row[sort.id] === undefined) {
            return -Infinity;
          }
          return typeof row[sort.id] === "string"
            ? row[sort.id].toLowerCase()
            : row[sort.id];
        };
      }),
      this.sorted.map(d => (d.desc ? "desc" : "asc"))
    );

    return sortedTableData;
  }

  @computed
  get getApprovalsChangesModalData() {
    return this.approvalsChangesModalData;
  }

  @computed
  get getSelectedTypes() {
    return this.selectedTypes;
  }

  @computed
  get getIncludeChanges() {
    return this.includeChanges;
  }

  @computed
  get getUseRegexPatternMatching() {
    return this.useRegexPatternMatching;
  }

  @computed
  get getApprovalStatusFilter() {
    return this.approvalStatusFilter;
  }

  @computed
  get getLatestSelectedReleaseOrDABranchBid() {
    return this.latestSelectedReleaseOrDABranchBid;
  }

  @computed
  get getPageCount() {
    return this.totalResultsCount === undefined || this.totalResultsCount === -1
      ? -1
      : Math.ceil(this.totalResultsCount / this.limit.limit);
  }

  @computed
  get getLimit() {
    return this.limit;
  }

  exportChangesInBid = (bid) => {
    this.exporter.setSelectedBranchId(bid)
    const exportParameters = {
      selectedExportSubFunction: ExportSubFunction.ENTITY_EXPORT,
      fileFormat: FILE_FORMAT.XLSX,
      onlyCurrentlyValidMetadata: false,
      onlyThisBranch: true
    }

    this.exporter.export(exportParameters)
  }

  getEntityFilterForApprovalsChangesData = (fetchParams) => {
    const {
      idsByKey,
      approvalStatusesAndBranchTypes,
      businessId,
      useRegexPatternMatching,
      approvalStatusFilter,
    } = fetchParams;

    // we support 3 objects from idsByKey object - if not filled, they are not put into entityFilter
    const key0 = Object.keys(idsByKey)[0];
    const key1 = Object.keys(idsByKey)[1];
    const key2 = Object.keys(idsByKey)[2];

   return {
      type: "Entity",
      [key0]: Object.values(idsByKey)[0],
      [key1]: Object.values(idsByKey)[1],
      [key2]: Object.values(idsByKey)[2],
      businessId: businessId
        ? {
            contains: useRegexPatternMatching ? null : businessId,
            regExp: useRegexPatternMatching ? businessId : null,
          }
        : null,
      approvalStatus:
        approvalStatusesAndBranchTypes.onlyApprovalStatuses &&
        approvalStatusesAndBranchTypes.onlyApprovalStatuses.length !== 0
          ? { in: approvalStatusesAndBranchTypes.onlyApprovalStatuses }
          : approvalStatusFilter === "ALL" || approvalStatusFilter === null
          ? null
          : { in: [approvalStatusFilter] },
      coreApprovalStatus:
        approvalStatusesAndBranchTypes.onlyCoreApprovalStatuses &&
        approvalStatusesAndBranchTypes.onlyCoreApprovalStatuses.length !== 0
          ? { in: approvalStatusesAndBranchTypes.onlyCoreApprovalStatuses }
          : approvalStatusFilter === "ALL" || approvalStatusFilter === null
          ? null
          : { in: [approvalStatusFilter] },
      typeOfBranch: approvalStatusesAndBranchTypes.onlyBranchTypes
        ? { in: approvalStatusesAndBranchTypes.onlyBranchTypes }
        : null,
    };
  }
  
}
